import React, {FC} from 'react';

import {isTeamNamespace} from '../../../../helpers/models/namespaceHelpers';
import {ChannelTwilioModel} from '../../../../models/api/channelModel';
import {InboxModel} from '../../../../models/api/inboxModel';
import {SettingsInboxesUrl} from '../../../../models/url/settingsUrlModel';
import {SettingsAddressField} from '../email/settingsAddressField';
import {
  ChannelAutoAssignField,
  ChannelReplyControlField,
  ChannelUndoSendTimingField,
  SettingsCommonChannelFieldProps,
} from '../settingsCommonChannelFields';

/*
 * Props.
 */

interface SettingsChannelTwilioFieldsProps extends SettingsCommonChannelFieldProps<ChannelTwilioModel> {
  inbox: InboxModel;
  url: SettingsInboxesUrl;
}

/*
 * Component.
 */

export const SettingsChannelTwilioFields: FC<SettingsChannelTwilioFieldsProps> = (props) => {
  const {edited, setDirty, onChange, onPreferencesChange} = props;
  const isSharedChannel = isTeamNamespace(props.edited.namespace);

  return (
    <div>
      <SettingsAddressField
        isDisabled
        edited={edited}
        setDirty={setDirty}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
      />
      <ChannelUndoSendTimingField
        edited={edited}
        setDirty={setDirty}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
      />
      {isSharedChannel && (
        <ChannelReplyControlField
          edited={edited}
          onChange={onChange}
          onPreferencesChange={onPreferencesChange}
          setDirty={setDirty}
        />
      )}
      <ChannelAutoAssignField
        edited={edited}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
        setDirty={setDirty}
      />
    </div>
  );
};
